var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaypal({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 40,
    viewBox: "0 0 116 68",
    preserveAspectRatio: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 111,
    height: 63,
    rx: 7.5,
    fill: "white",
    strokeWidth: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.0451 37.6955C50.7645 39.233 49.6523 46.4003 49.3231 48.4259C49.2987 48.5707 49.2423 48.6258 49.0822 48.6258H43.109C42.5004 48.6258 42.0597 48.0979 42.1404 47.5124L46.8336 17.731C46.954 16.9623 47.6421 16.378 48.4352 16.378C60.6314 16.378 61.6564 16.0821 64.7711 17.2916C69.5835 19.1571 70.0242 23.6581 68.2945 28.5268C66.5725 33.5404 62.4892 35.6942 57.0759 35.7582C53.6012 35.8146 51.5102 35.197 51.0463 37.6955H51.0451ZM70.7212 26.1719C70.5764 26.0681 70.5213 26.0271 70.4803 26.2757C70.3202 27.1879 70.0716 28.0771 69.7757 28.9663C66.5802 38.0798 57.7242 37.2867 53.4 37.2867C52.9118 37.2867 52.5915 37.5507 52.5275 38.0388C50.7183 49.2818 50.357 51.6278 50.357 51.6278C50.2763 52.1967 50.6376 52.6605 51.2052 52.6605H56.2905C56.9798 52.6605 57.5474 52.1557 57.6845 51.4676C57.7409 51.0358 57.5961 51.9558 58.8376 44.1568C59.2066 42.3951 59.9831 42.5796 61.1836 42.5796C66.8698 42.5796 71.3055 40.2733 72.6264 33.5865C73.1466 30.7998 72.9954 27.8683 70.7212 26.1706V26.1719Z",
    fill: "#1A4090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaypal);
export default __webpack_public_path__ + "static/media/paypal.fc9a12af69535f5278ad42af185c99c1.svg";
export { ForwardRef as ReactComponent };